import React from "react";
import HeroVideo1 from "../components/HeroVideo1";
import ImageText2 from "../components/Imagetext2";
import ImageText3 from "../components/ImageText3";
import RichText from "../components/RichText";

import video from "../assets/videos/egrsolutionsvideo.mp4";
import imageurl1 from "../assets/images/egrsolutions1.png";
import imageurl2 from "../assets/images/egrsolutions2.png";
import imageurl3 from "../assets/images/egrsolutions4.png";
import video2 from "../assets/videos/service2.mp4";

function EGRSolutions() {
  const text1 = (
    <>
      <p className="text-white text-lg">
        Het EGR(Exhaust Gas Recirculation) systeem zorgt ervoor dat de
        uitlaatgassen opnieuw de verbrandingskamer in gaan. Door dit proces
        wordt de temperatuur van de uitlaatgassen verminderd. Met als gevolg
        minder ontwikkeling van NOx uitstoot, wat weer beter is voor het milieu.
        Dit lijkt in eerste instantie een goede oplossing, maar het EGR systeem
        brengt vaak veel problemen met zich mee.
      </p>
    </>
  );

  const text2 = (
    <>
      <p className="text-white text-lg">
        De grootste EGR problemen ontstaan vaak door vervuiling. Uitlaatgassen
        brengen roet met zich mee, deze roet hoopt zich op in diverse
        leidingen/slangen en buizen van de auto. Na enige tijd worden de
        doorgangen, door de flinke laag roet, steeds kleiner. Het gevolg hiervan
        is dat er minder lucht in de cilinder kan. Dit leidt tot
        vermogensverlies, de motor houdt in en/of stottert tijdens het
        optrekken, het verbruik zal omhoog gaan en vaak gaat ook het
        storingslamp motormanagement branden.
      </p>
    </>
  );

  const text3 = (
    <>
      <p className="text-white text-lg">De optie die wij aanbieden;</p>
      <p className="text-white text-lg">
        - EGRuitschakelen. Wij kunnen deze compleet uitschakelen en zullen deze
        volledig wegprogrammerenin de software van uw auto. Dit is betreft de
        kosten de beste oplossing. Er zijn echter ook nadelen zoals: het
        mogelijk niet-naleven van emissienormen en/of garantieverlies. 
      </p>
      <p className="text-white text-lg">
        De volgende opties kunt u niet bij ons afnemen, maar zijn wel
        mogelijkheden:
      </p>
      <p className="text-white text-lg">- EGR vervangen</p>
      <p className="text-white text-lg">- EGR reinigen</p>
      <p className="text-white text-lg">
        Ook willen wij u erop attenderen dat als u kiest voor het vervangen of
        reinigen van uw EGR, dat er een kans bestaat dat het probleem op korte
        termijn weer zou kunnen voorkomen. Te lang doorrijden met een vervuilde
        EGR kan een vervuiling van andere motorcomponenten als gevolg hebben.
        Bij X-TREMETUNINGS bieden wij daarom de mogelijkheid om deze volledig
        uit te schrijven.
      </p>
    </>
  );

  const text4 = (
    <>
      <h3 className="text-[#BD0E0E] text-xl">LET OP!</h3>
      <br />
      <p className="text-white text-lg">
        Deze service is wegens de strenge milieunormen niet toegestaan op de
        openbare weg en is geheel op eigen risico van de klant!
      </p>
    </>
  );
  return (
    <div>
      <HeroVideo1 videoSource={video} heading="EGR Solutions" />
      <ImageText2
        text={text1}
        imageUrl={imageurl1}
        leftColor="#000"
        rightColor="#000"
        textColor="white"
        borderColor="#BD0E0E"
        borderWidth="2px"
      />
      <ImageText3
        text={text2}
        imageUrl={imageurl2}
        leftColor="#000"
        rightColor="#000"
        textColor="white"
        borderColor="#BD0E0E"
        borderWidth="2px"
      />
      <ImageText2
        heading="Watzijn de opties voor een defecte EGR?"
        text={text3}
        imageUrl={imageurl3}
        leftColor="#000"
        rightColor="#000"
        textColor="white"
        borderColor="#BD0E0E"
        borderWidth="2px"
      />
      <RichText text={text4} />
      <HeroVideo1
        videoSource={video2}
        heading="Benieuwd welke services er beschikbaar zijn voor uw auto?Kies uw auto voor de beschikbare services of klik hier om contact met ons op te nemen!"
        buttontext="Zoek uw optimalisatie"
        buttonlink="/contact-us"
      />
    </div>
  );
}

export default EGRSolutions;
